import { Check, Minus } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Checkbox as AriaCheckbox, type CheckboxProps as AriaCheckboxProps, Text } from "react-aria-components";
import { cx } from "@/lib/cx";

export interface CheckboxProps extends Omit<AriaCheckboxProps, "children" | "className"> {
  children: ReactNode;
  description?: ReactNode;
  className?: string;
}

export function Checkbox({ children, description, className, ...props }: CheckboxProps) {
  return (
    <AriaCheckbox
      className={cx("group flex items-start gap-2 text-sm text-fg data-disabled:opacity-50", className)}
      {...props}
    >
      {({ isSelected, isIndeterminate }) => (
        <>
          <span
            className={cx(
              "mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-mark border transition-colors duration-(--dur-fast)",
              isSelected || isIndeterminate
                ? "border-accent bg-accent text-accent-fg"
                : "border-input-border bg-input-bg group-data-hovered:border-input-border-hover",
              "group-data-invalid:border-input-border-invalid",
            )}
          >
            {isIndeterminate ? (
              <Minus size={12} weight="bold" aria-hidden="true" />
            ) : isSelected ? (
              <Check size={12} weight="bold" aria-hidden="true" />
            ) : null}
          </span>
          <span className="flex min-w-0 flex-col">
            <span>{children}</span>
            {description ? (
              <Text slot="description" className="text-xs text-fg-muted">
                {description}
              </Text>
            ) : null}
          </span>
        </>
      )}
    </AriaCheckbox>
  );
}
